import {gsap, TimelineLite} from "gsap";
import {DumpsterFire} from "../DumpsterFire";
import {DFGameConfig} from "../DFGameConfig";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";

export class finalMultiView extends PIXI.Container implements StageLayer {

    private _matrix: any = []

    constructor() {
        super();
        this.name = "finalMultiView";
        this.init();
    }


    public showFinalMultipliers(reelId: number, rowId: number, multiValue: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this.removeSpriteFromMatrix(reelId, rowId);
        }, 0)
        if (reelId >= 0 && reelId < 6 && rowId >= 0 && rowId < 5) {
            if (multiValue > 8192) {
                multiValue = 8192
            }
            const sprite: PIXI.Sprite = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures(`multi${multiValue}`)[0]);
            tl.add([() => {
                sprite.visible = true;
                this.addChild(sprite);
                this._matrix[reelId][rowId] = sprite;
            }]);
            sprite.x = reelId * DFGameConfig.symbolWidth - 5;  // Position the sprite with some padding
            sprite.y = rowId * DFGameConfig.symbolHeight + 70;  // Position the sprite with some padding
            tl.to(sprite, {duration: 0.1, alpha: 1});
        } else {
            console.log('Invalid position');
        }
        return tl;
    }

    public init() {
        for (let row: number = 0; row < 6; row++) {
            this._matrix[row] = [];
            for (let col: number = 0; col < 5; col++) {
                const sprite: PIXI.Sprite = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures(``)[0]);
                sprite.visible = false;
                sprite.x = col * 118;
                sprite.y = row * 118;

                // Push sprite into the matrix at position [row][col]
                this._matrix[row].push(sprite);
                // this._matrix[row][col].push(sprite);
                this.addChild(sprite);
            }
        }
    }

    private removeSpriteFromMatrix(reelId: number, rowId: number): void {
        const sprite: PIXI.Sprite = this._matrix[reelId][rowId];
        this.removeChild(sprite);
        this._matrix[reelId][rowId] = null;
    }

    public removeFinalMulti(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        for (let reelId: number = 0; reelId < 6; reelId++) {
            for (let rowId: number = 0; rowId < 5; rowId++) {
                const sprite: PIXI.Sprite = this._matrix[reelId][rowId];
                tl.add(() => {
                    this.removeChild(sprite);
                    this._matrix[reelId][rowId] = null;
                }, 0);
            }
        }
        return tl;
    }
}